import { BehaviorSubject } from 'rxjs';
import { PRENO_LOCAL_STORAGE_KEYS, STORAGE_KEYS } from '../../../shared/constants';
import * as moment from 'moment';
import * as i0 from "@angular/core";
import * as i1 from "../../../shared/services/stepper-form.service";
import * as i2 from "ngx-store";
import * as i3 from "../../../shared/services/http/auth.service";
import * as i4 from "./progress-bar.service";
export var FlowClass;
(function (FlowClass) {
    FlowClass["Default"] = "DEFAULT";
    FlowClass["ThirdPartReservation"] = "THIRD_PART_RESERVATION";
    FlowClass["DailyCode"] = "DAILY_CODE";
})(FlowClass || (FlowClass = {}));
export class StepperService {
    constructor(formService, localStorageService, authService, progressBarService) {
        this.formService = formService;
        this.localStorageService = localStorageService;
        this.authService = authService;
        this.progressBarService = progressBarService;
        this.selectedIndex = StepperService.isExpired() ? 0
            : localStorage.getItem(PRENO_LOCAL_STORAGE_KEYS.selectedIndex)
                ? parseInt(localStorage.getItem(PRENO_LOCAL_STORAGE_KEYS.selectedIndex))
                : 0;
        this.stepsPreno = StepperService.isExpired() ? []
            : localStorage.getItem(PRENO_LOCAL_STORAGE_KEYS.steps)
                ? JSON.parse(localStorage.getItem(PRENO_LOCAL_STORAGE_KEYS.steps))
                : [];
        this.steps = new BehaviorSubject([]);
        this.steps$ = this.steps.asObservable();
    }
    static isExpired() {
        const exp = localStorage.getItem(PRENO_LOCAL_STORAGE_KEYS.expirationDate);
        return exp ? moment().isAfter(moment(exp)) : false;
    }
    goTo() {
        this.manageSteps();
        let form = this.formService.getForm();
        let targetStep = '';
        if (form.controls['loggedIn'].value) {
            if (form.controls['phoneVerified'].value) {
                targetStep = 'confirm';
            }
            else {
                targetStep = 'otp';
            }
        }
        else {
            this.next();
            return;
        }
        const step = this.stepsPreno.find(s => s.name === targetStep);
        if (step) {
            this.selectedIndex = step.selectedIndex;
        }
        else {
            this.next();
            return;
        }
        localStorage.setItem(PRENO_LOCAL_STORAGE_KEYS.selectedIndex, this.selectedIndex.toString());
        this.scrollToTop();
    }
    goToAuth() {
        if (this.localStorageService.get('stepperData')) {
            const stepperData = this.localStorageService.get('stepperData');
            const isLoggedIn = stepperData.loggedIn;
            const phoneVerified = stepperData.phoneVerified;
            if (!isLoggedIn && !phoneVerified) {
                this.selectedIndex = this.stepsPreno.find(step => step.name === 'auth').selectedIndex;
                localStorage.setItem(PRENO_LOCAL_STORAGE_KEYS.selectedIndex, this.selectedIndex.toString());
            }
        }
    }
    goBack(stepper) {
        this.manageSteps();
        const step = this.stepsPreno.find(s => s.name === 'time');
        if (step) {
            stepper.selectedIndex = step.selectedIndex;
            localStorage.setItem(PRENO_LOCAL_STORAGE_KEYS.selectedIndex, stepper.selectedIndex);
        }
    }
    previous() {
        this.manageSteps();
        this.selectedIndex--;
        localStorage.setItem(PRENO_LOCAL_STORAGE_KEYS.selectedIndex, this.selectedIndex.toString());
        this.scrollToTop();
    }
    next() {
        this.manageSteps();
        this.selectedIndex++;
        localStorage.setItem(PRENO_LOCAL_STORAGE_KEYS.selectedIndex, this.selectedIndex.toString());
        this.scrollToTop();
    }
    manageSteps() {
        const form = this.formService.getForm();
        const isLoggedIn = form.get('roles') && form.get('roles').value;
        this.stepsPreno = [];
        const pushStep = (name, selectedIndex) => {
            this.stepsPreno.push({ name, selectedIndex: selectedIndex || this.stepsPreno.length });
        };
        pushStep('presidio');
        pushStep('materie');
        pushStep('data');
        pushStep('time');
        pushStep('confirm');
        pushStep('result');
        this.steps.next(this.stepsPreno);
        localStorage.setItem(PRENO_LOCAL_STORAGE_KEYS.steps, JSON.stringify(this.stepsPreno));
    }
    reset() {
        this.selectedIndex = 0;
        this.progressBarService.stopTimer();
        if (this.selectedIndex === 0) {
            for (const key of Object.values(STORAGE_KEYS.local)) {
                localStorage.removeItem(key);
            }
            for (const key of Object.values(STORAGE_KEYS.session)) {
                sessionStorage.removeItem(key);
            }
        }
    }
    scrollToTop() {
        const opts = { top: 0, behavior: 'smooth' };
        window.scrollTo(opts);
        document.documentElement.scrollTo(opts);
        document.body.scrollTo(opts);
        const el = document.querySelector('.scrollable-container');
        if (el) {
            el.scrollTo(opts);
        }
    }
}
StepperService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function StepperService_Factory() { return new StepperService(i0.ɵɵinject(i1.StepperFormService), i0.ɵɵinject(i2.LocalStorageService), i0.ɵɵinject(i3.AuthService), i0.ɵɵinject(i4.ProgressBarService)); }, token: StepperService, providedIn: "root" });
